export const SERVERID_COOKIE_KEY = 'schedule_recentsvrid_tl';
export const MIN_COOKIE_KEY = 'schedule_min_tl';
export const MAX_COOKIE_KEY = 'schedule_max_tl';
export const EVENTTYPE_COOKIE_KEY = 'schedule_eventtype_tl';

export const MOBILE_CNB_HEIGHT = 50;
export const PC_CNB_HEIGHT = 58;

export const DATELIST_HEIGHT_MOBILE = 66;
export const DATELIST_HEIGHT_PC = 80;

export const DIVICE_PC_WIDTH = 960;

export const BORDER_PC_LINE = 1;

export enum DAYS_OF_WEEK {
    '일',
    '월',
    '화',
    '수',
    '목',
    '금',
    '토',
}
